<template lang="pug">
#belief-statements-tab
  b-table(
    :data="statements"
    :current-page="pagination.page"
    :per-page="pagination.per"
    :total="pagination.total"
    @click="open"
    @dragstart="dragstart"
    @dragover="dragover"
    @dragleave="dragleave"
    @drop="drop"
    @page-change="getPage"
    backend-pagination
    draggable
    hoverable
    paginated
  )
    template(slot-scope="props")
      b-table-column(width="25")
        b-icon.drag-icon.has-text-grey-light(icon="drag-vertical")
      b-table-column(label="Heading")
        span {{ props.row.heading }}
      b-table-column(label="Body")
        span {{ props.row.body | truncate(75) }}
      b-table-column(label="Scriptures")
        span {{ props.row.scriptures_list }}
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import BeliefStatementForm from '@/components/form/BeliefStatementForm';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'belief-statements-tab',
  computed: {
    ...mapGetters({
      refresh: getters.GET_MINISTRY_REFRESH,
      statements: getters.GET_BELIEF_STATEMENTS,
    }),
  },
  created() {
    this.getPage(1);
  },
  data() {
    return {
      dragging: null,
      settings: {
        loading: false,
      },
      pagination: {
        page: 1,
        per: 12,
        total: 0,
      },
    };
  },
  methods: {
    dragstart(payload) {
      this.dragging = payload.row;
      payload.event.dataTransfer.effectAllowed = 'copy';
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy';
      payload.event.target.closest('tr').classList.add('is-selected');
      payload.event.preventDefault();
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      payload.event.preventDefault();
    },
    async drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      this.$store.commit(mutations.INSERT_BELIEF_STATEMENT, {
        index: payload.index,
        val: this.dragging,
      });
      const saveStatements = [];
      this.statements.forEach(statement => saveStatements.push(this.saveStatement(statement)));
      await Promise.all(saveStatements);
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: 'Sort order updated',
      });
    },
    async getPage(page) {
      this.settings.loading = true;
      this.pagination.page = page;
      const payload = { page };
      await this.$store.dispatch(actions.DO_GET_BELIEF_STATEMENTS, payload);
      setTimeout(() => {
        this.settings.loading = false;
        this.$store.commit(mutations.SET_MINISTRY_REFRESH, false);
      }, 250);
    },
    async open(statement) {
      await this.$store.dispatch(actions.DO_GET_BELIEF_STATEMENT, {
        id: statement.id,
        zoom: 'image',
      });
      this.$buefy.modal.open({
        parent: this,
        component: BeliefStatementForm,
        hasModalCard: true,
      });
    },
    async saveStatement(statement) {
      const index = _.findIndex(this.statements, { id: statement.id });
      if (index >= 0) {
        await this.$store.dispatch(actions.DO_UPDATE_BELIEF_STATEMENT, {
          id: statement.id,
          sort_order: index,
        });
      }
    },
  },
  watch: {
    refresh(val) {
      if (val) this.getPage(1);
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/BeliefStatementsTab.vue